import { render, staticRenderFns } from "./Menulist_RWD.vue?vue&type=template&id=ecb6dae6"
import script from "./Menulist_RWD.vue?vue&type=script&lang=js"
export * from "./Menulist_RWD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports